import React, { useContext, useEffect, useState } from "react";
import ProductContext from "../Context/productContext";
import "./PromoCode.css";
// MdDelete
import { MdDelete } from "react-icons/md";

const PromoCode = () => {
  const context = useContext(ProductContext);
  const { uploadPromoCode, getPromoCode, promocode, deletePromoCode } = context;
  useEffect(() => {
    getPromoCode();
  }, []);
  const [code, setPromoCode] = useState("");
  const [percent, setPercent] = useState("");
  const [error, setError] = useState("");

  const handleClick = (e) => {
    e.preventDefault();
    if (code && percent) {
      setError("");
      uploadPromoCode(code, percent);
      setPromoCode("");
      setPercent("");
    } else {
      setError("Fill All the Details");
    }
  };
  return (
    <>
      <div
        class="modal fade"
        id="promocodeModal"
        tabindex="-1"
        aria-labelledby="promocodeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Promo Code
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="addPromoCode">
                <form>
                  <div class="row g-3">
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                      <label htmlFor="code" className="form-label">
                        Promo Code
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="code"
                        aria-label="code"
                        value={code}
                        onChange={(e) => setPromoCode(e.target.value)}
                      />
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                      <label htmlFor="percent" className="form-label">
                        Discount Percent
                      </label>

                      <input
                        type="number"
                        class="form-control"
                        aria-label="percent"
                        value={percent}
                        onChange={(e) => setPercent(e.target.value)}
                      />
                    </div>
                    <div class="col my-4">
                      <button
                        class="btn btn-primary mt-4"
                        onClick={handleClick}
                      >
                        Add Promo Code
                      </button>
                    </div>
                  </div>
                </form>
                <p style={{ color: "red" }}>{error}</p>
              </div>

              <div
                className="active-promo-code-container"
                style={{ height: "100%" }}
              >
                <div className="container">
                  <h4>Active Promo Code</h4>
                  <div className="row my-3">
                    <div className="col-5 fw-bold ">Promo Code</div>
                    <div className="col-5 fw-bold">Percent Discount</div>
                    <div className="col-2 fw-bold">Delete</div>
                  </div>
                  {promocode.map((item) => {
                    return (
                      <div className="row my-2 border-bottom" key={item.id}>
                        <div className="col-5">{item.promocode}</div>
                        <div className="col-5">{item.percent} %</div>
                        <div className="col-2">
                          <MdDelete style={{cursor:'pointer',color:'red'}} onClick={() => deletePromoCode(item.id)} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoCode;
